import React from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  // Button,
  // UncontrolledCollapse
} from 'reactstrap';
import clock from '../assets/clock_xxh.png';

const Timeout = ({confirmIsOpen, confirmClose}) => {
  return (
    <Modal className="modal-message align-items-center justify-content-center" size='sm' isOpen={confirmIsOpen} toggle={() => confirmClose()}>
      <ModalBody className="pb-2" style={{minHeight: '120px'}}>
        <div className="d-flex flex-column align-items-center align-items-center">
			<img src={clock} alt='clock' style={{width: '70px'}} />
        </div>
      </ModalBody>
      <div>
        <span className={`btn-small d-block text-center mt-4 mx-3`} id="toggler">
            Maaf, sistem lagi ada kendala. Bang Otto lagi coba benerin nih
        </span>
        <center className="align-middle" style={{padding: '0 1.2rem'}}>
          {/* <label className="small">Silahkan mencoba kembali atau Anda bisa menghubungi call center kami di <b>021 - 1500 749</b> atau WhatsApp <b>081113015749</b></label> */}
          <label className="small">Yuk coba lagi. Jika membutuhkan bantuan kamu bisa menghubungi Customer Service.</label>
        </center>
      </div>
      <ModalFooter className='text-center'>
		    <button className="btn btn-primary btn-rounded2" onClick={() => confirmClose()}>Tutup</button>
      </ModalFooter>
    </Modal>
  );
}

export default Timeout


// import React from 'react';
// import {
// 	Modal,
// 	ModalBody,
//     ModalFooter,
//     Spinner
// } from 'reactstrap';

// const Timeout = ({
// 	confirmIsOpen,
// 	confirmClose, }) => {
// 	return (
// 		<Modal className="modal-loading align-items-center justify-content-center" size='sm' isOpen={confirmIsOpen} toggle={() => confirmClose()}>
// 			<ModalBody className="align-self-center">
// 				<div className="row">
//                     <label className="align-self-center ml-3 mr-3" >
//                             Timeout
//                     </label>
// 				</div>
// 			</ModalBody>
// 		</Modal>
// 	);
// }

// export default Timeout
